import React from "react"
import PropTypes from "prop-types"
import { Avatar } from "source/shared/components"

const NameBanner = ({ person, info, onClick, linkText }) => (
  <div className="my-4">
    <h2 className="h4 mb-1">{info}</h2>
    <div className="d-f ai-c jc-sb action-drawer">
      <div className="d-f">
        <div className="mr-2">
          <div className="h-6 w-6">
            <Avatar
              url={person.data.attributes.avatar_url}
              alt={` Profile image of ${person.data.attributes.name}`}
              size={6}
            />
          </div>
        </div>
        <div className="d-f fd-c">
          <div>{person.data.attributes.name}</div>
          <div className="fs-13 c-tint2">
            {person.data.attributes.email_address}
          </div>
        </div>
      </div>
      {onClick && linkText && (
        <button type="button" className="link-button" onClick={onClick}>
          {linkText}
        </button>
      )}
    </div>
  </div>
)

NameBanner.propTypes = {
  person: PropTypes.shape({
    data: PropTypes.shape({
      attributes: PropTypes.shape({
        avatar_url: PropTypes.string,
        name: PropTypes.string,
        email_address: PropTypes.string,
      }),
    }),
  }).isRequired,
  info: PropTypes.node,
  onClick: PropTypes.func,
  linkText: PropTypes.node,
}

export default NameBanner
